export enum ValidationType {
  Document = 'Document',
  Other = 'Other',
}